import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StrategyEffects } from './strategy.effects';
import * as fromStrategy3A from './reducers/strategy-3a.reducers';
import * as fromStrategyCH from './reducers/strategy-ch.reducers';
import * as fromStrategyUI from './reducers/strategy-ui.reducers';
import * as fromStrategy from './reducers/strategy.reducers';

import { SharedModule } from '@shared/shared.module';

import * as fromComponents from './components';
import { StrategyRoutingModule } from './strategy-routing.module';
import { StrategyComponent } from './strategy.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    StrategyRoutingModule,
    EffectsModule.forFeature([StrategyEffects]),
    SharedModule,
    StoreModule.forFeature(fromStrategy.STRATEGY_REDUCER_FEATURE_KEY, fromStrategy.reducer),
    StoreModule.forFeature(fromStrategy3A.STRATEGY_3A_REDUCER_FEATURE_KEY, fromStrategy3A.reducer),
    StoreModule.forFeature(fromStrategyCH.STRATEGY_CH_REDUCER_FEATURE_KEY, fromStrategyCH.reducer),
    StoreModule.forFeature(fromStrategyUI.STRATEGY_UI_REDUCER_FEATURE_KEY, fromStrategyUI.reducer),
    TranslateModule
  ],
  exports: [],
  declarations: [...fromComponents.components, StrategyComponent],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class StrategyModule {}
